// src/components/BlockCard.js
import React from "react";
import { Card } from "react-bootstrap";
import "./DistrictCard.css";

const BlockCard = ({ blockName, onClick }) => {
  return (

     <Card className="district-card" onClick={() => onClick(blockName)}>
          <Card.Body className="district-card-body">
            <h5 className="district-card-title">{blockName?.toUpperCase()}</h5>
          </Card.Body>
        </Card>
  );
};

export default BlockCard;
